import { Head } from '@inertiajs/react'
import { Navbar } from '@/components/landing/Navbar'
import { HeroSection } from '@/components/landing/HeroSection'
import { FeaturesSection } from '@/components/landing/FeaturesSection'
import { HowItWorksSection } from '@/components/landing/HowItWorksSection'
import { CodeExampleSection } from '@/components/landing/CodeExampleSection'
import { PricingSection } from '@/components/landing/PricingSection'
import { InterestSection } from '@/components/landing/InterestSection'
import { Footer } from '@/components/landing/Footer'

interface Props {
  flash_message?: string | null
  interest_errors?: string[] | null
}

export default function Home({ flash_message, interest_errors }: Props) {
  return (
    <div className="min-h-screen">
      <Head>
        <title>KonexZero — Realtime Voice, Video & Screen Sharing APIs</title>
        <meta name="description" content="Build realtime communication into any app. Voice, video, and screen sharing APIs with sub-100ms latency. Simple REST API — no SDK required." />
      </Head>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorksSection />
        <CodeExampleSection />
        <PricingSection />
        <InterestSection
          flashMessage={flash_message}
          interestErrors={interest_errors}
        />
      </main>
      <Footer />
    </div>
  )
}
